import { useState, useEffect } from 'react';
import { Tag } from 'lucide-react';
import Marquee from 'react-fast-marquee';
import api from '../lib/api';

export function TickerPromocoes() {
  const [promocoes, setPromocoes] = useState([]);

  useEffect(() => {
    api.get('/promocoes').then(res => setPromocoes(res.data)).catch(() => {});
  }, []);

  if (promocoes.length === 0) return null;

  return (
    <div className="bg-[#E1F5EE] border-y border-[#9FE1CB] py-2.5 overflow-hidden" data-testid="ticker-promocoes">
      <Marquee speed={50} pauseOnHover gradient={false}>
        {promocoes.map((p, i) => (
          <span key={i} className="inline-flex items-center gap-2 mx-8 text-sm text-[#085041] whitespace-nowrap">
            <Tag size={13} className="text-[#1D9E75]" />
            <span className="font-medium">{p.titulo}</span>
            {p.precoPromocional && (
              <span className="text-[#1D9E75] font-semibold">
                R${Number(p.precoPromocional).toFixed(2).replace('.', ',')}
              </span>
            )}
            <span className="text-[#9FE1CB] mx-1">•</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
